import httpSvc from './HttpSvc'
import { DS_ROUTES } from '@/core/constants'

export async function getTabs() {
  const resp = await httpSvc.get(DS_ROUTES.purple_ribbon_awards_tabs)
  return resp.data
}

export function getAwardTitles(awardData) {
  return _mapAwardCategoryOptionsToKeyValue(awardData.categories)
}

export function getAwardNoOrganizationSizes(awardData) {
  return _mapAwardCategoryToKeyNoOrgValue(awardData.categories)
}

export function getParsedAwardData(awardData) {
  let awards = [];
  Object.values(awardData.categories).forEach(val => {
    val["awards"].forEach(award => {
      awards.push(award)
    })
  });
  return awards;
}

export async function getAwards() {
  const resp = await httpSvc.get(DS_ROUTES.purple_ribbon_awards_awards)
  return resp.data
}

export async function getWinners() {
  // ugh
  // const resp = await httpSvc.get(DS_ROUTES.purple_ribbon_awards_winners)
  const resp = await httpSvc.get("/api/awards/winners.json")
  return resp.data
}

export async function getSupporters() {
  const resp = await httpSvc.get(DS_ROUTES.purple_ribbon_awards_supporters)
  return resp.data
}

export async function getSponsors() {
  const resp = await httpSvc.get('/api/awards/sponsors.json')
  return resp.data
}

export async function getJudges() {
  const resp = await httpSvc.get(DS_ROUTES.purple_ribbon_awards_judges)
  return resp.data
}

export async function getOrganizationSizes() {
  const resp = await httpSvc.get(DS_ROUTES.purple_ribbon_awards_organization_sizes)
  return _mapOptionsToKeyValue(resp.data)
}

/**
 * Maps the array from the API to an array of { key: value } pairs
 * The two endpoints it is used for use both `title` and `name`,
 * so we need to account for either or.
 * @param  {Array} array The array from the API. Looks like [{id: '123', name: 'Name'}]
 * @return {Array}       The array of the same length, mapped to  [{id: name||title}]
 */
function _mapOptionsToKeyValue(array) {
  return array.reduce((obj, e) => ({...obj, [e.id]: (e.name || e.title)}), {})
}

function _mapOptionsToKeyNoOrgValue(array) {
  return array.reduce((obj, e) => ({...obj, [e.id]: (e.no_organization_size)}), {})
}

function _mapAwardCategoryToKeyNoOrgValue(object) {
  let awardData = [];
  Object.values(object).forEach(val => {
    awardData.push(val["awards"][0])
  });

  return _mapOptionsToKeyNoOrgValue(awardData);
}

function _mapAwardCategoryOptionsToKeyValue(object) {

  let parsedData = [];

  Object.values(object).forEach(val => {
    const awardValues = _mapOptionsToKeyValue(val["awards"]);
    parsedData.push({
      name: val["name"],
      data: awardValues
    })
  });

  return parsedData;
}
